<template>
  <RygenChip
    class="waterfall-tender-status-chip"
    :class="{ chonky }"
    :label="label"
    :severity="severity"
  />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { translateEnum } from '@rygen/rygen-ui/i18n';
import { Severity } from '@rygen/rygen-ui/model';

import { WaterfallTenderStatus } from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  status: {
    type: String as PropType<WaterfallTenderStatus>,
    default: () => undefined,
  },
  chonky: {
    type: Boolean,
    default: () => false,
  },
});
const { chonky, status } = toRefs(props);
const { t } = useI18n();

const label = computed((): string => {
  return status?.value
    ? translateEnum(status.value, 'WaterfallTenderStatus')
    : t('common.loading');
});

const severity = computed((): Severity | undefined => {
  switch (status?.value) {
    case WaterfallTenderStatus.NOT_STARTED:
      return Severity.INFO_LIGHT;
    case WaterfallTenderStatus.IN_PROGRESS:
      return Severity.SUCCESS_LIGHT;
    case WaterfallTenderStatus.COMPLETED_SUCCESSFULLY:
      return Severity.INFO;
    case WaterfallTenderStatus.COMPLETED_WITHOUT_ACCEPTED_RATE_QUOTE:
      return Severity.DANGER;
    case WaterfallTenderStatus.CANCELED:
      return Severity.DANGER_LIGHT;
    default:
      return undefined;
  }
});
</script>

<style>
.rygen-chip.waterfall-tender-status-chip {
  &.chonky {
    --p-chip-padding-x: var(--sp-2);
    --p-chip-padding-y: var(--sp-2);
    --p-chip-border-radius: var(--sp-1);

    .p-chip-text {
      font-size: 12px;
    }
  }
}
</style>
